module.exports = __webpack_public_path__ + "media/images/online/top/reason1-78a2e64c4bfc49ef5b3f5a28281df6d7.jpg";